<template>
  <div>
    <div class="register-container">
      <img style="width: 100%" src="../assets/topbg.png" />
      <div
        style="
          margin-top: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img style="width: 50%" src="../assets/CREATE.png" alt="CREATE Image" />
      </div>
      <div class="content">
        <div class="box">
          <p class="zi">phone</p>
          <div class="put">
            <van-form validate-first @failed="onFailed">
              <van-field
                label-width="36px"
                label="+91"
                v-model="memberPhone"
                type="tel"
                placeholder="Your phone number"
                :rules="[
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message:
                      'Please enter a valid phone number starting with 6, 7, 8, or 9',
                  },
                ]"
              />
            </van-form>
          </div>
        </div>
        <div class="box">
          <p class="zi">Password</p>
          <div class="put">
            <van-field
              v-model="memberPwd"
              :type="passwordType"
              placeholder="Your password"
            >
              <template slot="right-icon">
                <span class="solts" @click="switchPasswordType">
                  <van-icon name="eye" v-if="passwordType === 'text'" />
                  <van-icon name="closed-eye" v-else />
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <div class="box">
          <p class="zi">Password Again</p>
          <div class="put">
            <van-field
              v-model="memberPwdAgain"
              :type="passwordType1"
              placeholder="Your password"
            >
              <template slot="right-icon">
                <span class="solts" @click="switchPasswordType1">
                  <van-icon name="eye" v-if="passwordType1 === 'text'" />
                  <van-icon name="closed-eye" v-else />
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <div class="box">
          <p class="zi">Invite Code</p>
          <div class="put">
            <van-field
              v-model="inviteCode"
              disabled
              class="custom-green-text"
            />
          </div>
        </div>
        <div class="box">
          <p class="zi">Captchat Code</p>
          <div class="put">
            <van-field v-model="captchaCode" placeholder="Your captchat code">
              <template slot="right-icon">
                <span class="solts" @click="changeImg">
                  <van-image width="70px" fit="fill" :src="img" />
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <van-button
          @click="submit"
          style="
            margin-top: 40px;
            height: 48px;
            font-family: Source Sans Variable;
            font-weight: bold;
            font-size: 24px;
            border-radius: 12px;
          "
          color="#66CC33"
          block
          :disabled="isDisabled"
          >SIGN IN</van-button
        >
        <p
          style="
            margin-top: 24px;
            text-align: center;
            font-family: Source Sans Variable;
            font-weight: 400;
            color: #66cc33;
          "
        >
          Already have an account?
        </p>
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop>
          <van-loading type="spinner" color="#1989fa" />
        </div>
      </van-overlay>
    </div>
    <van-popup round style="width: 90%" v-model="success">
      <div class="dialog-content">
        <div class="title-container">
          <div class="title">
            <span>Registration successful</span>
          </div>
        </div>
        <p class="ds">
          Download the APP and start your money-making journey right away
        </p>
        <div class="app-icon">
          <img src="../assets/Spro Deal-i@2x.png" />
          <p>Spro Deal</p>
        </div>
        <van-button color="#282c38" class="vb" @click="downloadApp">
          <span style="font-weight: 600; color: #fff; font-size: 18px">
            Download the app</span
          >
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { captcha, register } from '@/api'
import { Button } from 'vant'
import Vue from 'vue'
Vue.use(Button)
import { Popup } from 'vant'
Vue.use(Popup)
import { Field } from 'vant'
Vue.use(Field)
import { Form } from 'vant'
Vue.use(Form)
import { Icon } from 'vant'
Vue.use(Icon)
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import { Loading } from 'vant'
import { Overlay } from 'vant'
Vue.use(Overlay)
Vue.use(Loading)
import { Notify } from 'vant'
Vue.use(Notify)
export default {
  data() {
    return {
      memberPhone: '',
      memberPwd: '',
      memberPwdAgain: '',
      passwordType: 'text',
      passwordType1: 'text',
      inviteCode: '',
      captchaCode: '',
      img: '',
      uuid: '',
      downloadLink: '',
      show: false,
      success: false,
    }
  },
  computed: {
    isDisabled() {
      return (
        this.memberPhone == '' ||
        this.memberPwd == '' ||
        this.memberPwd.length < 6 ||
        this.memberPwdAgain == '' ||
        this.memberPwdAgain.length < 6 ||
        this.inviteCode == '' ||
        this.captchaCode == ''
      )
    },
  },
  methods: {
    // downloadApp() {
    //   const link = document.createElement("a"); // 创建一个临时的下载链接
    //   link.href = this.downloadLink;
    //   link.target = "_blank"; // 设置在新标签页中打开链接
    //   link.download = "UKPay.apk"; // 设置下载的文件名
    //   link.click(); // 触发点击下载
    // },
    // downloadApp() {
    //   // 1. 使用 fetch 获取 APK 文件
    //   fetch(this.downloadLink)
    //     .then((response) => {
    //       // 确保请求成功
    //       if (!response.ok) {
    //         throw new Error("Network response was not ok");
    //       }
    //       return response.blob(); // 将文件转为 Blob 对象
    //     })
    //     .then((blob) => {
    //       // 2. 使用 FileSaver.js 保存文件
    //       saveAs(blob, "UKPay.apk"); // 'UKPay.apk' 是下载后的文件名
    //     })
    //     .catch((error) => {
    //       console.error("Download failed:", error);
    //     });
    // },
    downloadApp() {
      // 直接在新标签页中打开文件链接
      window.open(this.downloadLink, '_blank')
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo)
    },
    submit() {
      this.show = true
      let params = {
        memberPhone: this.memberPhone,
        memberPwd: this.memberPwd,
        memberPwdAgain: this.memberPwdAgain,
        inviteCode: this.inviteCode,
        captchaCode: this.captchaCode,
        uuid: this.uuid,
      }
      register(params, {
        packageName: 'com.nh.spro.deal',
      })
        .then((res) => {
          console.log('res', res)

          if (res.downloadLink) {
            this.success = true
            this.downloadLink = res.downloadLink
          } else {
            Notify({ type: 'warning', message: res.message })
          }
          this.getImg()
          this.show = false
        })
        .catch((err) => {
          console.log('🚀 ~ submit ~ err:', err)
          this.show = false
          Notify({ type: 'warning', message: err.message })
          this.getImg()
        })
    },
    getImg() {
      captcha(
        {},
        {
          packageName: 'com.nh.spro.deal',
        }
      ).then((res) => {
        this.img = res.captchaImg
        this.uuid = res.uuid
      })
    },
    changeImg() {
      this.getImg()
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchPasswordType1() {
      this.passwordType1 =
        this.passwordType1 === 'password' ? 'text' : 'password'
    },
    submitForm() {
      // Logic to handle form submission
      console.log('Form submitted', this.form)
    },
    goToLogin() {
      // Logic to navigate to login page
      this.$router.push('/login')
    },
  },
  created() {
    this.getImg()
  },
  mounted() {
    this.inviteCode = this.$route.query.inviteCode
  },
}
</script>

<style scoped>
.register-container {
  padding-bottom: 60px;
}

.content {
  padding: 0 30px;
}
.box {
  margin-top: 20px;
}
.zi {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #666666;
  margin-bottom: 12px;
}
.van-cell {
  background: rgba(109, 181, 254, 0);
  border-radius: 15px;
  border: 1px solid #eeeeee;
}
/deep/ .van-field__label {
  font-family: Source Sans Variable;
  font-weight: bold;
  font-size: 15px;
  color: #666666;
}
.van-button__text {
  color: #000;
}
/deep/ .van-field__control {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #111111;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.success-icon {
  font-size: 80px;
  color: #4caf50;
  margin-bottom: 20px;
}

.success-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
}

.success-description {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 40px;
}

/* 背景动画 - 彩带效果 */
.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #ffeb3b;
  top: -10%;
  animation: confetti-fall 5s linear infinite;
}

.confetti:nth-child(2) {
  background-color: #f44336;
  left: 20%;
  animation-delay: 1s;
}

.confetti:nth-child(3) {
  background-color: #2196f3;
  left: 40%;
  animation-delay: 2s;
}

.confetti:nth-child(4) {
  background-color: #4caf50;
  left: 60%;
  animation-delay: 3s;
}

.confetti:nth-child(5) {
  background-color: #ff9800;
  left: 80%;
  animation-delay: 4s;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
  }
}
.dialog-content {
  text-align: center;
  padding: 20px;
}

.app-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.app-icon img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
.title-container {
  width: 100%;
  padding-top: 20px;
}

.title {
  font-size: 1.3rem;
  position: relative;
  display: inline-block;
  color: #000; /* 标题文字的颜色 */
}

.title span {
  display: inline-block;
  position: relative;
  z-index: 1; /* 确保文字在背景色之上 */
}

.title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; /* 控制绿色背景的高度 */
  background-color: #66cc33; /* 背景色 */
  z-index: 0; /* 确保背景色在文字下面 */
}
.ds {
  margin-top: 12px;
  color: #8d8d8d;
  font-size: 12px;
}
.vb {
  width: 100%;
  border-radius: 12px;
}
.custom-green-text ::v-deep .van-field__control:disabled {
  color: #66cc33;
  -webkit-text-fill-color: #66cc33;
}
</style>
